"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));
var _ixdIconsReact = require("@tencent/ixd-icons-react");
var _utils = require("../../utils");
var _Collapse = _interopRequireDefault(require("../SceneTabsImageFull/Collapse"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/no-unknown-property */

var TabPane = _FlexTabContainer["default"].TabPane;
/**
 * 横向布局的 Tab + 横向布局的文字与图片展示
 */
var SceneTabsHorizontal = function SceneTabsHorizontal(_a) {
  var _b = _a.flexTitle,
    flexTitle = _b === void 0 ? '' : _b,
    configuration = _a.configuration,
    className = _a.className,
    restProps = __rest(_a, ["flexTitle", "configuration", "className"]);
  // 判断是否使用的样式类型 -pc or mobile
  var _c = (0, _react.useState)(true),
    isPc = _c[0],
    setIsPc = _c[1];
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setIsPc);
  }, []);
  var renderContent = function renderContent(item, index) {
    var _a = item || {},
      content = _a.content,
      descTitle = _a.descTitle,
      descList = _a.descList,
      btnText = _a.btnText,
      btnHref = _a.btnHref,
      rightImage = _a.rightImage;
    var _b = (0, _utils.fomateFileData)(rightImage),
      url = _b.url,
      alt = _b.alt;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "scene-tabpanel__flex"
    }, /*#__PURE__*/_react["default"].createElement("section", null, !!content && /*#__PURE__*/_react["default"].createElement("div", {
      className: "scene-tabpanel__content"
    }, content), /*#__PURE__*/_react["default"].createElement("div", {
      className: "scene-tabpanel__desc-cell"
    }, /*#__PURE__*/_react["default"].createElement("p", null, descTitle), /*#__PURE__*/_react["default"].createElement("ul", null, descList === null || descList === void 0 ? void 0 : descList.map(function (row, rowIdx) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: rowIdx,
        title: row === null || row === void 0 ? void 0 : row.text
      }, /*#__PURE__*/_react["default"].createElement(_ixdIconsReact.SuccessIcon, null), /*#__PURE__*/_react["default"].createElement("span", null, (row === null || row === void 0 ? void 0 : row.text) || ''));
    }))), !!btnText && (/*#__PURE__*/_react["default"].createElement("a", {
      className: "scene-tabpanel__btn",
      href: btnHref,
      "report-event": "click_sceneTabs_extra_link",
      "report-ext1": index,
      "report-ext2": btnText || '',
      "report-ext3": btnHref || ''
    }, btnText))), /*#__PURE__*/_react["default"].createElement("img", {
      src: url,
      alt: alt
    }));
  };
  // PC 端 tabs 布局
  var renderPcTabs = function renderPcTabs() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "scene-container__pc"
    }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], null, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, idx) {
      var _a = item || {},
        key = _a.key,
        tabTitle = _a.tabTitle;
      return /*#__PURE__*/_react["default"].createElement(TabPane, {
        key: idx,
        tabIndex: key,
        title: tabTitle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        // ...... 需要带上 ant-tabs-content-holder__section 样式才能首次正常隐藏
        className: "ant-tabs-content-holder__section"
      }, renderContent(item, idx)));
    })));
  };
  // 移动端 tabs 布局
  var renderMobileTabs = function renderMobileTabs() {
    var tabs = (configuration || []).map(function (item, idx) {
      return {
        key: item.key || '',
        label: item.tabTitle,
        children: renderContent(item, idx)
      };
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "scene-container__mobile"
    }, /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      tabs: tabs
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", __assign({}, restProps, {
    className: (0, _classnames["default"])(className, 'scene-tabs-horizontal-container')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "scene-container-root"
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), isPc ? renderPcTabs() : renderMobileTabs()));
};
SceneTabsHorizontal.displayName = 'SceneTabsHorizontal';
var _default = exports["default"] = SceneTabsHorizontal;